/**
 * The device's IANA time zone (e.g. "America/New_York"), resolved once per load.
 * Sent to the server so day-bucketed features — the daily streak (TEX-2237) and
 * the 5/day quiz cap (TEX-2334) — agree on the player's LOCAL day across every
 * path that reads or enforces them. Empty string if unavailable, in which case
 * the server falls back to its default zone.
 */
export const LOCAL_TZ: string = (() => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
})();
